// Function to get query parameters from the URL
function getQueryParams(url) {
  let params = {};
  let parser = new URL(url);
  let queryString = parser.search.slice(1);

  // Split the query string by '&' and process each part
  queryString.split("&").forEach((part) => {
    // Split each part into key and value
    let [key, value] = part.split("=");
    // Decode URI components
    key = decodeURIComponent(key);
    value = decodeURIComponent(value);
    
    params[key] = value;
  });

  return params;
}

// Function to add items to cart
function addToCart(updates) {
  let items = Object.keys(updates).map((id) => ({
    id: id,
    quantity: updates[id],
  }));
  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ items }),
  })
    .then((response) => response.json())
    //.then((data) => console.log("Items added:", data))
    .catch((error) => console.error("Error:", error));
}

// Function to clear the cart
function clearCart() {
  return fetch("/cart/clear.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((response) => response.json())
    //.then((data) => console.log("Cart cleared:", data))
    .catch((error) => console.error("Error:", error));
}

// Main function
function main() {
  let url = window.location.href;
  let params = getQueryParams(url);
  const cartLink = document.querySelector("#cart-icon-bubble");

  // Check if utm_source is Klaviyo
  if (params["utm_source"] === "Klaviyo") {
    let updates = {};
    let hasUpdates = false;

    // Capture updates with their ID and QTY
    for (let key in params) {
      if (key.startsWith("updates_")) {
        let id = key.slice(8);
        updates[id] = parseInt(params[key], 10);
        hasUpdates = true;
      }
    }

    // If there are updates, clear the cart and add the new items
    if (hasUpdates) {
      clearCart().then(() => {
        addToCart(updates);
        checkProductsInCart();
        slate.cart.cartIconCount();
        cartLink.click();
      });
    }
  }
}

main();
